export function getCookie(name) {

    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {

        const value = parts.pop().split(";").shift();

        if (value.indexOf("{") === -1) {
            return value;
        } else {
            return JSON.parse(value);
        }
    }

    return null;
}

export function setCookie(name, value) {
    document.cookie = name + "=" + value + "; path=/";
}
